import React, { useState, useContext } from 'react';
import { ThemeContext } from '../theme';
import ProfileTabBar from '../components/ProfileTabBar';
import InputField from '../components/InputField';
import SelectField from '../components/SelectField';
import Button from '../components/Button';

// Same DP used in SelectProfileScreen / ManageProfileScreen
const EDA_URL = 'https://res.cloudinary.com/dcnujnpbm/image/upload/q_auto/f_auto/v1776961468/eda_dp_fszpol.webp';

const SCALE = 0.75;
const sc = (n) => Math.round(n * SCALE);

const LANGUAGE_OPTIONS    = ['English (default)', 'Turkish', 'Spanish', 'French', 'German'];
const IDENTITY_OPTIONS    = ['Irish (default)', 'Turkish', 'British', 'American', 'Australian'];

export default function EditProfileScreen({ onTabChange, onSave }) {
  const theme = useContext(ThemeContext);
  const [profileName, setProfileName] = useState('Eda');
  const [email,       setEmail]       = useState('eda_yildiz@gmail.com');
  const [password,    setPassword]    = useState('');
  const [language,    setLanguage]    = useState('English (default)');
  const [identity,    setIdentity]    = useState('Irish (default)');

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', backgroundColor: theme.bg100, overflow: 'hidden' }}>

      {/* Rounded card */}
      <div
        style={{
          flex: 1,
          margin: sc(16),
          backgroundColor: theme.cardBg,
          borderRadius: sc(30),
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        <ProfileTabBar active="manage-profile" onTabChange={onTabChange} />

        {/* Scrollable form body */}
        <div
          style={{
            flex: 1,
            overflowY: 'auto',
            padding: `${sc(28)}px ${sc(40)}px ${sc(36)}px`,
            display: 'flex',
            flexDirection: 'column',
            gap: sc(24),
          }}
        >
          {/* ── Photo row ── */}
          <div style={{ display: 'flex', alignItems: 'center', gap: sc(24) }}>
            {/* Circular avatar */}
            <img
              src={EDA_URL}
              alt="Profile"
              style={{
                width: sc(120),
                height: sc(120),
                borderRadius: '50%',
                objectFit: 'cover',
                flexShrink: 0,
              }}
            />

            {/* Upload + hint */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: sc(12) }}>
              <Button variant="tertiary" scale={SCALE} style={{ width: sc(154) }}>
                Upload
              </Button>
              <span
                className="font-satoshi"
                style={{ fontSize: sc(16), lineHeight: `${sc(24)}px`, color: theme.text400, fontWeight: 500 }}
              >
                At least 500 x 500px PNG or JPF file
              </span>
            </div>

            {/* Push Save to the far right */}
            <div style={{ flex: 1 }} />

            <Button variant="primary" onClick={onSave} scale={SCALE} style={{ minWidth: sc(148) }}>
              Save
            </Button>
          </div>

          {/* ── Personal Information ── */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: sc(20) }}>
            <h2
              className="font-satoshi font-bold"
              style={{ margin: 0, fontSize: sc(22), lineHeight: `${sc(32)}px`, color: theme.text100 }}
            >
              Personal Information
            </h2>

            <div style={{ display: 'flex', gap: sc(20) }}>
              <InputField
                label="Profile Name"
                required
                value={profileName}
                onChange={e => setProfileName(e.target.value)}
                scale={SCALE}
              />
              <InputField
                label="E-mail"
                required
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                scale={SCALE}
              />
              <InputField
                label="Password"
                required
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••••••••••••••"
                scale={SCALE}
              />
            </div>
          </div>

          {/* ── Preferences ── */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: sc(20) }}>
            <h2
              className="font-satoshi font-bold"
              style={{ margin: 0, fontSize: sc(22), lineHeight: `${sc(32)}px`, color: theme.text100 }}
            >
              Preferences
            </h2>

            {/* 2 dropdowns, ~2/3 of the row width (matching Figma proportions) */}
            <div style={{ display: 'flex', gap: sc(20), width: '66%' }}>
              <SelectField
                label="Language"
                options={LANGUAGE_OPTIONS}
                value={language}
                onChange={setLanguage}
                scale={SCALE}
                dropUp
              />
              <SelectField
                label="Cultural Identity"
                options={IDENTITY_OPTIONS}
                value={identity}
                onChange={setIdentity}
                scale={SCALE}
                dropUp
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
